/* eslint-disable react-hooks/exhaustive-deps */
import './list.scss';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { list, authority } from '../../services/saas/active';
import { ListView, Toast, PullToRefresh, Modal } from 'antd-mobile';
import { useHistory } from 'react-router';
import { ActiveItem, ActiveLiveItem, ResItem } from './item';
import sysConfig from '@/sysConfig';
import { getApp, getUser, toConference } from '../../utils';
import { info as liveChannelDetail } from '../../services/saas/liveChannel';
import { getResAttrModelList, getResModelList } from '../../services/saas/res';
import { getResList } from '../../services/saas/studio';
import Filter from '@/components/filter';
import { MyContext } from '@/utils/contextManager';
import SearchWrapper from '@/components/searchWrapper';
import ShowEmpty from '@/components/showEmpty';
import { getConnections } from '../../services/saas/fileInfo';
import { info as lessonDetail } from '../../services/saas/active';

const { preRouteUrl } = sysConfig;

const Alert = Modal.alert;

export function StudioInteractList(props) {
  const [activeList, setActiveList] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  const type = [
    { key: 'hdlb', value: '活动列表', finished: 0 },
    { key: 'hdhk', value: '活动回看', finished: 1 },
  ];
  const [selected, setSelected] = useState('hdlb');
  const [finished, setFinished] = useState(0);

  const history = useHistory();

  const { appId } = getApp() || {};
  const getStudioInteract = async () => {
    await setActiveList(false);
    await setHasMore(false);
    const param = {
      current: 1,
      size: 4,
      releaseStatus: 1,
      sourceId: props.studioId,
      sourceModule: props.studioType,
      sourceApp: props.sourceApp || appId,
      finished: finished,
      sortField: finished === 1 ? '' : 'asc',
    };
    const response = await list(param);
    if (response.success && response.data.records.length > 0) {
      setActiveList(response.data.records);
      setHasMore(response.data.total > response.data.size);
    }
  };

  const forwordTo = async (id, status) => {
    if (status === '0') {
      Toast.info('尚未开始');
      return;
    }
    if (status === '2') {
      Toast.info('已结束');
      return;
    }
    if (status === '1') {
      const { userId } = getUser();
      const confirm = (text) => {
        Alert('是否进入直播', text, [
          { text: '取消', onPress: null },
          { text: '确定', onPress: () => history.push(`${preRouteUrl}/livePlay/lesson/${id}`) },
        ]);
      };
      try {
        const resp = await authority({ lessonId: id, userId });
        if (resp.success && resp.data) {
          const result = resp.data;
          if (result.permission === 1) {
            if (!result.isFull || result.userInfo.role === '4') {
              if (
                (result.conferenceInfo && result.conferenceInfo.isLocked === 0) ||
                result.userInfo.role === '4'
              ) {
                toConference(result);
              } else {
                confirm('会议已锁定，是否进入直播？');
              }
            } else {
              confirm('参与人数已达到上限，是否进入直播？');
            }
          } else {
            Toast.info('无参与权限！');
          }
        }
      } catch (err) {
        Toast.info(err);
      }
    }
  };

  const handleClick = (item) => {
    if (finished) {
      if (item.replayable) {
        history.push(`${preRouteUrl}/livePlayback/lesson/${item.id}`);
      } else {
        Toast.info('该活动未开启回看！');
      }
    } else {
      forwordTo(item.id, item.lessonProgressStatus);
    }
  };

  useEffect(() => {
    getStudioInteract();
  }, [selected]);

  return (
    <div className="studioInteractList">
      <div className="headers">
        {type.map((item) => (
          <button
            className={`header${selected === item.key ? ' selected' : ''}`}
            key={item.key}
            onClick={() => {
              setSelected(item.key);
              setFinished(item.finished);
            }}
          >
            {item.value}
          </button>
        ))}
      </div>
      {activeList ? (
        <div className="activeList">
          {activeList.map((item) => (
            <div className="item" key={item.id} onClick={() => handleClick(item)}>
              <ActiveItem
                cover={item.coverUrl}
                name={item.lessonName}
                time={item.startTime}
                status={item.lessonProgressStatus}
              />
            </div>
          ))}
        </div>
      ) : (
        <ShowEmpty />
      )}
      {hasMore ? (
        <div style={{ textAlign: 'center' }}>
          <button
            className="btn"
            onClick={() => {
              history.push(
                `${preRouteUrl}/studio/studioInteractMore?sourceApp=${props.sourceApp}&studioId=${props.studioId}&type=${finished}`,
              );
            }}
          >
            <span>查看更多</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}

export function StudioLive(props) {
  const [liveInfo, setLiveInfo] = useState(false);

  const history = useHistory();

  const { appId } = getApp() || {};

  const getLiveList = async () => {
    const param = {
      stateSection: 'now',
      sourceApp: props.sourceApp || appId,
      sourceId: props.studioId,
    };
    const resp = await list(param);
    if (resp.success && resp.data.records.length > 0) {
      const { id, liveStatus } = resp.data.records[0];
      const respDetail = await lessonDetail({ id: id });
      if (respDetail.success) {
        const { coverUrl, lessonName, startTime, streamId } = respDetail.data;
        let interactParam = { streamId: streamId };
        setLiveInfo({
          id: id,
          coverUrl: coverUrl,
          name: lessonName,
          time: startTime,
          viewNum: await getViewNum(streamId, interactParam),
          liveStatus: liveStatus,
        });
      }
    }
  };

  const getLiveChannel = async () => {
    const resp = await liveChannelDetail({ id: props.liveChannelId });
    if (resp.success) {
      let liveChannelParam = { fileInfoId: resp.data.fileInfoId };
      setLiveInfo({
        id: resp.data.id,
        coverUrl: resp.data.coverUrl,
        name: resp.data.activityName,
        time: resp.data.createTime ? resp.data.createTime.replace('T', ' ') : '',
        viewNum: await getViewNum(resp.data.fileInfoId, liveChannelParam),
        liveStatus: resp.data.liveStatus,
      });
    }
  };

  const getViewNum = async (id, params) => {
    let viewNum = 0;
    if (id) {
      const respConnect = await getConnections(params);
      if (respConnect.success) {
        respConnect.data.forEach((item) => {
          viewNum += item.viewClients;
        });
      }
    }
    return viewNum;
  };

  useEffect(() => {
    if (props.type === 'liveChannel') {
      getLiveChannel();
    }
    if (props.type === 'lesson') {
      getLiveList();
    }
  }, []);

  return liveInfo.liveStatus === '1' ? (
    <div className="liveList">
      <div
        className="item"
        onClick={() =>
          history.push(`${preRouteUrl}/livePlay/${props.type}/${liveInfo.id}`)
        }
      >
        <ActiveLiveItem
          cover={liveInfo.coverUrl}
          name={liveInfo.name}
          time={liveInfo.time}
          viewNum={liveInfo.viewNum}
          status={liveInfo.liveStatus}
        />
      </div>
    </div>
  ) : (
    <ShowEmpty />
  );
}

export function Resource(props) {
  const { onChange } = props;
  const [resModelList, setResModelList] = useState(false);
  const [selected, setSelected] = useState(props.resTypeId || false);
  const [code, setCode] = useState(false);
  const { appId } = getApp() || {};

  const resModelMapper = new Map([]);

  const getResModel = async () => {
    let modelList = [];
    const resp = await getResModelList({ isIssue: '1', appId: props.sourceApp || appId });
    if (resp.success && resp.data.length > 0) {
      resp.data.forEach((item) => {
        resModelMapper.set(item.modelId, item);
      });
    }
    const response = await getResAttrModelList({ appId: props.sourceApp || appId });
    if (response.success && response.data.length > 0) {
      response.data.forEach((item) => {
        const model = resModelMapper.get(item.modelId);
        modelList.push({
          title: model.modelName,
          value: item.modelId,
          code: model.modelCode,
        });
      });
      const initionId = selected || response.data[0].modelId;
      const initionCode = resModelMapper.get(response.data[0].modelId).modelCode;
      setResModelList(modelList);
      setSelected(initionId);
      setCode(initionCode);
      if (onChange) {
        onChange(initionId, initionCode);
      }
    }
  };

  useEffect(() => {
    getResModel();
  }, []);

  return (
    <>
      <div className={`resModel ${props.className}`}>
        {resModelList &&
          resModelList.map((item) => (
            <button
              className={`${selected === item.value ? 'active' : ''}`}
              key={item.value}
              onClick={() => {
                setSelected(item.value);
                setCode(item.code);
                if (onChange) {
                  onChange(item.value, item.code);
                }
              }}
            >
              <span className={`${item.code} ${selected === item.value ? 'selected' : ''}`}>
                {item.title}
              </span>
            </button>
          ))}
      </div>
      {!onChange && selected && code && (
        <ResList
          resMore={props.resMore}
          resTypeId={selected}
          sourceApp={props.sourceApp || appId}
          sourceId={props.studioId}
          sourceModule={props.studioType}
          size={code === 'VIDEO' ? 4 : 3}
          class={code === 'VIDEO' ? 'video' : 'text-pic'}
          resType={code === 'VIDEO' ? '1' : '2'}
        />
      )}
    </>
  );
}

function ListWrap(props) {
  return <div className="studioRes-list">{props.children}</div>;
}
export function ResList(props) {
  const history = useHistory();
  const [resList, setResList] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  let [pageIndex, setIndex] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  const [moreBtn, setMoreBtn] = useState(false);
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const [keyValue, setKeyValue] = useState('');
  const [filter, setFilter] = useState({});
  const { setFilters } = useContext(MyContext);

  const getRes = async (page) => {
    setLoading(true);
    if (page === 1) {
      setResList([]);
      setData([]);
      setDataSouce(dataSource.cloneWithRows([]));
    }
    const { appId } = getApp() || {};
    const { startTime, endTime } = filter;
    const param = {
      current: page || 1,
      size: props.resMore ? 6 : props.size,
      issueFlag: 1,
      sourceApp: props.sourceApp || appId,
      resType: props.resTypeId,
      sourceId: props.sourceId,
      title: keyValue,
      startIssueTime: startTime,
      endIssueTime: endTime,
    };
    const resp = await getResList(param);
    if (resp.success && resp.data) {
      const resourceList = (page === 1 ? [] : data).concat(resp.data.records);
      setResList(resp.data.records);
      setDraging(false);
      setLoading(false);
      setData(resourceList);
      setDataSouce(dataSource.cloneWithRows(resourceList));
      setHasMore(resp.data.current < resp.data.pages);
      setIndex(page);
      setMoreBtn(resp.data.total > props.size);
    }
  };

  useEffect(() => {
    getRes(1);
  }, [props.resTypeId, filter, keyValue]);

  useEffect(() => {
    if (props.resMore) {
      setFilters(
        <Filter
          data={[]}
          handleSearch={(item) => {
            setFilter(item);
          }}
        ></Filter>,
      );
    }
  }, []);

  const onEndReached = function () {
    if (!loading && hasMore) {
      getRes(++pageIndex);
    }
  };

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const { resId, title, coverUrl, deptName, createrName, viewNum, resType } = rowData;
    return (
      <div className="studioRes-list-item" key={rowID}>
        <ResItem
          id={resId}
          name={title}
          cover={coverUrl}
          dept={deptName}
          teacher={createrName}
          viewNum={viewNum}
          resType={resType}
        />
      </div>
    );
  };

  return props.resMore ? (
    <>
      <SearchWrapper className="searchDuery" onChange={setKeyValue}></SearchWrapper>
      <ListView
        ref={listRef}
        dataSource={dataSource}
        renderHeader={false}
        renderFooter={() => (
          <div style={{ padding: 10, textAlign: 'center' }}>
            {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="studioRes-list-wrap"
        pageSize={6}
        onScroll={() => {
          console.log('scroll');
        }}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            onRefresh={() => {
              setDraging(true);
              getRes(1);
            }}
          />
        }
      />
    </>
  ) : (
    <>
      <div style={{ padding: 10, textAlign: 'center', display: loading ? 'block' : 'none' }}>
        加载中...
      </div>
      <div style={{ display: !loading ? 'block' : 'none' }}>
        {resList.length > 0 ? (
          <div className="resList">
            {resList.map((item) => (
              <div className={props.class} key={item.resId}>
                <ResItem
                  id={item.resId}
                  name={item.title}
                  cover={item.coverUrl}
                  dept={item.deptName}
                  teacher={item.createrName}
                  viewNum={item.viewNum}
                  resType={props.resType}
                />
              </div>
            ))}
          </div>
        ) : (
          <ShowEmpty />
        )}
        {moreBtn && !loading && (
          <div style={{ textAlign: 'center' }}>
            <button
              className="btn"
              onClick={() => {
                history.push(
                  `${preRouteUrl}/studio/resMore?sourceModule=${props.sourceModule}&sourceId=${props.sourceId}&resType=${props.resTypeId}`,
                );
              }}
            >
              <span>查看更多</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
}
